import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { Snackbar, Alert } from '@mui/material';
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Botlogin from "./Botlogin";
import { useDispatch, useSelector } from "react-redux";
import {
  savebotAction,
  getBotByUserIdAction,
  getBotLoginAction,
  updateBotAction,
  savebotsignupAction,
  getBotCompanyAction
} from "../../redux/actions/botAction";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import DatePickerBot from "./DatePickerBot";



const formatDate = (date) => {
  if (!date) return "";
  const formattedDate = dayjs(date);
  return formattedDate.isValid() ? formattedDate.format("MM-DD-YYYY") : "";
};

export default function SignupBot() {
  const [entries, setEntries] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [flag, setFlag] = useState(false);
  const [refreshUser, setRefreshUser] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(14);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const userId = useSelector((state) => state.user?.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logindetails = useSelector((state) => state.bot.getLoginBot);
  const botResponse = useSelector((state) => state.bot.getBots);
  const botcompanydetails = useSelector((state) => state.bot.getbotcompany);
  const botcompanyvalue=botcompanydetails.content || [];
  const staticCarrierNames = botcompanyvalue.slice(-10).map((item) => item.carrierName);
  const dynamicName = botcompanyvalue.slice(0, 4).map((item) => item.carrierName);
  const loginid = userId?.id || [];
  const email = userId?.email || [];

  const staticEntries = staticCarrierNames.map((carrierName, index) => ({
    id: `static-${index + 1}`,
    carrierName,
    startDate: "",
    carrierAgencyCode: "",
    carrierAgencyUserId: "",
    carrierAgencyUserPassword: "",
    status: "Coming Soon",
    isReadOnly: true,
    isPrefilled: true,
    displayNumber: index + 3,
  }));

  useEffect(() => {
    dispatch(getBotLoginAction());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getBotCompanyAction(page,
      rowsPerPage));
  }, [dispatch,page, rowsPerPage]);

  useEffect(() => {
    if (logindetails && logindetails.length > 0) {
      const userFound = logindetails.some((entry) => entry.userId === loginid);
      setFlag(userFound);
    }
    dispatch(getBotByUserIdAction(loginid));
  }, [logindetails, loginid]);


  useEffect(() => {
    const carrierNames = dynamicName;

    const botResponseArray = Array.isArray(botResponse)
      ? botResponse
      : (botResponse ? [botResponse] : []);

    const dynamicEntries = carrierNames.map((carrierName, index) => {
      const existingEntry = botResponseArray.find(
        entry => entry.carrierName === carrierName
      );

      if (existingEntry) {
        return {
          ...existingEntry,
          originalId: existingEntry.id,
          id: existingEntry.id,
          displayNumber: index + 1,
          startDate: existingEntry.startDate,
          checked: true,
          isEditing: false,
          isPrefilled: true,
          status: existingEntry.status || "",
          isReadOnly: false,
          carrierNameReadOnly: true,
          carrierName: carrierName
        };
      } else {
        return {
          id: `empty-${index}`,
          displayNumber: index + 1,
          startDate: "",
          checked: false,
          isEditing: false,
          isPrefilled: false,
          status: "",
          isReadOnly: false,
          carrierNameReadOnly: true,
          carrierName: carrierName
        };
      }
    });

    setEntries([...dynamicEntries, ...staticEntries]);
  }, [botResponse]);

  const handleBotLoginSubmit = async (formData) => {
    try {
      const hasEmptyFieldInFormData = Object.values(formData).some((value) => !value);

      if (hasEmptyFieldInFormData) {
        setRefreshUser(false);
        setSnackbarMessage('Please fill out all required fields before submitting.');
        setSnackbarOpen(true);
        return false;
      }

      const selectedEntries = entries
        .filter((entry) => entry.checked && !entry.isReadOnly)
        .map((entry) => ({
          carrierName: entry.carrierName,
          startDate: entry.startDate,
          carrierAgencyCode: entry.carrierAgencyCode,
          carrierAgencyUserId: entry.carrierAgencyUserId,
          carrierAgencyUserPassword: entry.carrierAgencyUserPassword,
          status: entry.status,
          purchasedByUserId: loginid,
          purchasedByUserEmail: email,
        }));

      const hasEmptyFieldInSelectedEntries = selectedEntries.some((entry) => {
        return (
          !entry.carrierName ||
          !entry.startDate ||
          !entry.carrierAgencyUserId ||
          !entry.carrierAgencyUserPassword
        );
      });


      if (hasEmptyFieldInSelectedEntries) {
        setRefreshUser(false);
        setSnackbarMessage('Please fill out all required fields in the entries before saving.');
        setSnackbarOpen(true);
        return;
      }
      setRefreshUser(true);
      await dispatch(savebotsignupAction(formData));


      if (selectedEntries.length > 0) {
        setRefreshUser(true);
        await dispatch(
          savebotAction(selectedEntries, (response) => {
            if (response) {
              dispatch(getBotByUserIdAction(loginid));

            }
          })
        );
      }
    } catch (error) {
      console.error("Error in form submission:", error);
    }
  };

  const handleSave = (id) => {
    const entryToUpdate = entries.find((entry) => entry.id === id);

    if (
      entryToUpdate &&
      !entryToUpdate.isReadOnly &&
      entryToUpdate.originalId
    ) {
      const updatedEntry = {
        id: entryToUpdate.originalId,
        carrierName: entryToUpdate.carrierName,
        startDate: formatDate(entryToUpdate.startDate),
        carrierAgencyCode: entryToUpdate.carrierAgencyCode,
        carrierAgencyUserId: entryToUpdate.carrierAgencyUserId,
        carrierAgencyUserPassword: entryToUpdate.carrierAgencyUserPassword,
        status: entryToUpdate.status || "Active",
        purchasedByUserId: loginid,
        purchasedByUserEmail: email,
      };

      try {

        dispatch(updateBotAction(updatedEntry));
        dispatch(getBotByUserIdAction(loginid));
        window.location.reload();
        setSnackbarMessage('Data updated successfully!');
        setSnackbarOpen(true);
      } catch (error) {
        console.error("Error in updateBotAction:", error);
      }
    }

    setEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === id ? { ...entry, isEditing: false } : entry
      )
    );
  };

  const handleInputChange = (id, field, value) => {
    const entry = entries.find((e) => e.id === id);
    if (entry?.isReadOnly) return;

    if (field === "carrierName" && entry?.carrierNameReadOnly) return;

    const lettersOnly = /^[A-Za-z]*$/;
    const numbersOnly = /^[0-9]*$/;
    const maxLength = 20;

    if (field === "startDate") {
      setEntries((prevEntries) =>
        prevEntries.map((entry) =>
          entry.id === id ? { ...entry, [field]: value } : entry
        )
      );
      return;
    }

    if (field === "status") {
      setEntries((prevEntries) =>
        prevEntries.map((entry) => {
          if (entry.id === id) {
            const isActivated = value === "Active";
            if (!entry.isReadOnly) {
              if (entry.isPrefilled && entry.originalId) {
                const updatedEntry = {
                  id: entry.originalId,
                  carrierName: entry.carrierName,
                  startDate: formatDate(entry.startDate),
                  carrierAgencyCode: entry.carrierAgencyCode,
                  carrierAgencyUserId: entry.carrierAgencyUserId,
                  carrierAgencyUserPassword: entry.carrierAgencyUserPassword,
                  status: value,
                  purchasedByUserId: loginid,
                  purchasedByUserEmail: email,
                };

                dispatch(
                  updateBotAction(updatedEntry, (response) => {
                    dispatch(getBotByUserIdAction(loginid));
                  })
                );
              }
              return {
                ...entry,
                [field]: value,
                checked: isActivated,
              };
            }
            return { ...entry, [field]: value };
          }
          return entry;
        })
      );
      return;
    }

    if (field === "carrierName") {
      if (!lettersOnly.test(value) || value.length > maxLength) return;
    } else if (field === "carrierAgencyCode") {
      if (!numbersOnly.test(value) || value.length > maxLength) return;
    }

    setEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const handleCheckboxChange = (id) => {
    setEntries((prevEntries) =>
      prevEntries.map((entry) => {
        if (entry.id === id && !entry.isReadOnly) {
          const newChecked = !entry.checked;
          if (entry.isPrefilled) {
            const newStatus = newChecked ? "Active" : "Inactive";
            if (entry.originalId) {
              const updatedEntry = {
                id: entry.originalId,
                carrierName: entry.carrierName,
                startDate: formatDate(entry.startDate),
                carrierAgencyCode: entry.carrierAgencyCode,
                carrierAgencyUserId: entry.carrierAgencyUserId,
                carrierAgencyUserPassword: entry.carrierAgencyUserPassword,
                status: newStatus,
                purchasedByUserId: loginid,
                purchasedByUserEmail: email,
              };

              dispatch(
                updateBotAction(updatedEntry, (response) => {
                  dispatch(getBotByUserIdAction(loginid));
                })
              );
            }
            return {
              ...entry,
              checked: newChecked,
              status: newStatus,
            };
          }
          return { ...entry, checked: newChecked };
        }
        return entry;
      })
    );
  };

  const handleEdit = (id) => {
    const entry = entries.find((e) => e.id === id);
    if (entry?.isReadOnly) return;

    setEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === id && entry.isPrefilled
          ? { ...entry, isEditing: true }
          : entry
      )
    );
  };

  const handleSaveAll = () => {
    const selectedEntries = entries
      .filter((entry) => entry.checked && !entry.isReadOnly)
      .map((entry) => ({
        carrierName: entry.carrierName,
        startDate: formatDate(entry.startDate),
        carrierAgencyCode: entry.carrierAgencyCode,
        carrierAgencyUserId: entry.carrierAgencyUserId,
        carrierAgencyUserPassword: entry.carrierAgencyUserPassword,
        status: entry.status || "Active",
        purchasedByUserId: loginid,
        purchasedByUserEmail: email,
        id: entry.originalId || null,
      }));

    const hasEmptyField = selectedEntries.some((entry) => {
      return (
        !entry.carrierName ||
        !entry.startDate ||
        !entry.carrierAgencyUserId ||
        !entry.carrierAgencyUserPassword
      );
    });

    if (hasEmptyField) {
      setSnackbarMessage('Please fill out all required fields before saving.');
      setSnackbarOpen(true);
      return;
    }

    const newEntries = selectedEntries.filter((entry) => !entry.id);
    const existingEntries = selectedEntries.filter((entry) => entry.id);

    if (newEntries.length > 0) {
      dispatch(
        savebotAction(newEntries, (response) => {
          if (response) {
            dispatch(getBotByUserIdAction(loginid));
            setSnackbarMessage('Data saved successfully!');
            setSnackbarOpen(true);
          }
        })
      );
    }

    existingEntries.forEach((entry) => {
      dispatch(updateBotAction(entry));
      setSnackbarMessage('Data updated successfully!');
      setSnackbarOpen(true);
    });
  };



  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleSignup = () => {
    setDialogOpen(true);
    setFormVisible(true);
  };

  const handleCancel = () => {
    navigate("/home");
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setFormVisible(false);
  };

  return (
    <div className="max-w-4xl mx-auto" >

      <Box sx={{padding: "16px 50px", marginTop: '50px' }}>
          <Grid className="section-title" spacing={2}>
              <Typography
                        variant="h2"
                        gutterBottom
                      >
              Signup Bot
            </Typography>
            {flag && (
              <Button variant="contained" onClick={handleSignup}>CRM</Button>
            )}
      </Grid>
  </Box>


  <form onSubmit={handleSubmit}>
  <Grid container spacing={2} sx={{ px: "32px" }}>
    {entries.map((entry) => (
      <Grid item xs={12} key={entry.id}>
        <Card
          variant="outlined"
          sx={{
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            '&:hover': { boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }
          }}
        >
          <CardContent sx={{ pt: 2, pb: 2 }}>
            <Grid container spacing={2} alignItems="center">
            <FormControlLabel
      control={
        <Checkbox
          checked={entry.checked}
          onChange={() => handleCheckboxChange(entry.id)}
         
        />
      }
      sx={{ pl: 2 }}
    />
              <Grid item xs={8} sm={5} md={1.6}>
                <Typography variant="body1" sx={{
                  mb: 1,
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  color: '#333'
                }}>
                  Carrier Name
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={entry.carrierName}
                  variant="outlined"
                  onChange={(e) => handleInputChange(entry.id, "carrierName", e.target.value)}
                  InputProps={{
                    readOnly: entry.carrierNameReadOnly || (entry.isPrefilled && !entry.isEditing) || entry.isReadOnly,
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={1.8}>
                <Typography variant="body1" sx={{
                  mb: 1,
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  color: '#333'
                }}>
                  Start Date
                </Typography>
                
              <DatePickerBot
                  entry={entry}
                  handleInputChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={1.8}>
                <Typography variant="body1" sx={{
                  mb: 1,
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  color: '#333'
                }}>
                  Carrier Agency Code
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={entry.carrierAgencyCode}
                  variant="outlined"
                  onChange={(e) => handleInputChange(entry.id, "carrierAgencyCode", e.target.value)}
                  InputProps={{
                    readOnly: entry.isPrefilled && !entry.isEditing,
                  }}
                />
              </Grid>

<Grid item xs={12} sm={6} md={1.8}>
  <Typography variant="body1" sx={{
    mb: 1,
    fontFamily: 'Poppins',
    fontWeight: 500,
    color: '#333'
  }}>
    Carrier Agency User Id
  </Typography>
  <TextField
    fullWidth
    size="small"
    value={entry.carrierAgencyUserId}
    variant="outlined"
    onChange={(e) => {
      const inputValue = e.target.value;
      const regex = /^[a-zA-Z0-9]*([.@]?[a-zA-Z0-9]+)*$/;
      const dotCount = (inputValue.match(/\./g) || []).length;
      const atCount = (inputValue.match(/@/g) || []).length;

      if (inputValue.length <= 50 && regex.test(inputValue) && dotCount <= 1 && atCount <= 1) {
        handleInputChange(entry.id, "carrierAgencyUserId", inputValue);
      }
    }}
    InputProps={{
      readOnly: entry.isPrefilled && !entry.isEditing,
    }}
  />
</Grid>

<Grid item xs={12} sm={6} md={2.2}>
  <Typography variant="body1" sx={{
    mb: 1,
    fontFamily: 'Poppins',
    fontWeight: 500,
    color: '#333',
    whiteSpace: 'nowrap'
  }}>
    Carrier Agency Password
  </Typography>
  <TextField
    fullWidth
    size="small"
    type="password"
    value={entry.carrierAgencyUserPassword}
    variant="outlined"
    onChange={(e) => handleInputChange(entry.id, "carrierAgencyUserPassword", e.target.value)}
    InputProps={{
      readOnly: entry.isPrefilled && !entry.isEditing,
    }}
  />
</Grid>

<Grid item xs={10} sm={5} md={1.6}>
  <Typography variant="body1" sx={{
    mb: 1,
    fontFamily: 'Poppins',
    fontWeight: 500,
    color: '#333'
  }}>
    Status
  </Typography>
  {entry.isReadOnly ? (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      value={entry.isReadOnly ? entry.status || "Coming Soon" : entry.status}
      onChange={(e) => {
        if (!entry.isReadOnly) {
          handleInputChange(entry.id, "status", e.target.value);
        }
      }}
      InputProps={{
        readOnly: entry.isReadOnly,
      }}
    />
  ) : (
    <FormControl fullWidth size="small" variant="outlined">
      <Select
        value={entry.status || "coming soon"}
        onChange={(e) => handleInputChange(entry.id, "status", e.target.value)}
        disabled={entry.isPrefilled && !entry.isEditing}
      >
        <MenuItem value="Active">Active</MenuItem>
        <MenuItem value="Inactive">Inactive</MenuItem>
      </Select>
    </FormControl>
  )}
</Grid>


<Grid item xs={10} sm={8} md={0.5} sx={{ display: 'flex', alignItems: 'flex-end', height: '100%', pb: 1 }}>
  <CardHeader
    sx={{
      p: 0,
      m: 0,
      '& .MuiCardHeader-action': {
        margin: 0,
        alignSelf: 'flex-end'
      }
    }}
    action={
      entry.isPrefilled && !entry.isReadOnly ? (
        entry.isEditing ? (
          <IconButton
            onClick={() => handleSave(entry.id)}
          >
            <SaveIcon />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => !entry.isReadOnly && handleEdit(entry.id)}
            disabled={entry.isReadOnly}
          >
            <EditIcon />
          </IconButton>
        )
      ) : null
    }
  />
</Grid>

                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Typography
    variant="body2"
    color="textSecondary"
    sx={{
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "19.6px",
      textAlign: "center",
      my: 4
    }}
  >
    Minimum Cost $100 per month, Cancel Anytime *2 cent for each information
  </Typography>

  <Grid className="footer-section" gap={2}>
    <Button
      id="submitbutton"
      onClick={handleCancel}
      variant="outlined"
    >
      Cancel
    </Button>

    <Button
      id="actionButton"
      type="submit"
      onClick={flag ? handleSaveAll : handleSignup}
      variant="outlined"
    >
      {flag ? "Save" : "Signup"}
    </Button>
  </Grid>
</form>

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Signup Confirmation</DialogTitle>
        <DialogContent>
          <Botlogin
            toggleform={handleCloseDialog}
            onSubmitSuccess={handleBotLoginSubmit}
            logindetails={logindetails}
            loginid={loginid}
            refreshUser={refreshUser}
          />
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}
